import { render, staticRenderFns } from "./EmailInputBlock.vue?vue&type=template&id=90b87772"
import script from "./EmailInputBlock.vue?vue&type=script&lang=ts"
export * from "./EmailInputBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports